<template>
  <div class="box has-text-centered">
    <section>
      <p class="title is-size-5">Clean anonymous recordings</p>
      <div class="columns">
        <div class="column">
          <b-field label="Duration (from) (s):">
            <b-numberinput v-model="lengthLow"></b-numberinput>
          </b-field>
          <b-field label="Duration (to) (s):">
            <b-numberinput v-model="lengthHigh"></b-numberinput>
          </b-field>
        </div>
      </div>
      <b-button type="is-primary" @click="clean" :loading="cleaning" expanded
        >Clean</b-button
      >
    </section>
  </div>
</template>

<script>
import dataService from "../../services/dataService";
export default {
  data() {
    return {
      lengthLow: 0,
      lengthHigh: 0,
      cleaning: false
    };
  },
  methods: {
    async clean() {
      if (this.lengthLow > this.lengthHigh) return;
      this.cleaning = true;
      await dataService.cleanAnonymousRecordings(
        this.lengthLow,
        this.lengthHigh
      );
      this.cleaning = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
